import { render, staticRenderFns } from "./ButtonRadioGroup.vue?vue&type=template&id=465a8de8"
import script from "./ButtonRadioGroup.vue?vue&type=script&lang=js"
export * from "./ButtonRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports